  <template>
  <div class="element-wrapper pb-2">
    <div class="SearchContainer ">
    <div class="SearchForm">
      <label class="InputContainer FormLabel ">
        <div class="InputWrap">
          <input class="SearchWrapper ComponentGameSearch GameSearch SearchInput" v-on:focus="openSearch" v-model="search" :placeholder="place" type="text">
        </div>
      </label>
      <button class="CloseButton ComponentButton InstanceTipicoCloseSearchButton Button" type="button">
        <span class="ButtonText">Abbrechen</span>
      </button>
    </div>
      <span class="ComponentIcon InstanceIconSearch Icon SearchIconEnd">
                    <span class="SvgIcon MainIcon">
                       <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 99.25 99.25">
                          <path d="M97.73 90.4l-24-24a41.17 41.17 0 10-7.32 7.33l24 24a5.18 5.18 0 107.32-7.33zM63.01 63.01a30.84 30.84 0 110-43.62 30.64 30.64 0 010 43.62z"></path>
                       </svg>
                    </span>
      </span>
    </div>
    <div class="element-search autosuggest-search-activator">

      <div class="search-with-suggestions-w over-search-field" :class="showBox">
        <div class="search-with-suggestions-modal">

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import sportIcon from '@/components/ui/asset/sportIcon';
  export default {
    name: 'gameSearch',
    components: {sportIcon},
    props: {
      place: {
        Type: String,
        default: 'Search...'
      },
      group: {
        Type: String,
        default: 'Client'
      },
      live: {
        Type: String,
        default: null
      },
    },
    data () {
      return {
        session: session,
        t: this.$root.t,
        api: window.api,
        search: '',
        show: false,
        events: null,
        total: 0,
        selected: null
      }
    },
    watch: {
      '$route' () {
        this.show = false;
      },
      search () {
        this.fetchUsers();
      }
    },
    computed: {
      showBox () {
        return (this.show) ? 'show' : 'hide';
      }
    },
    methods: {
      openSearch () {
        this.show = true;
        this.events = null;
        this.search = ''
      },
      closeSearch () {
        this.show = false;
        this.search = ''
      },
      selectUser (user) {
        this.selected = null;
        this.$emit('selected', user);
        this.selected = user;
        this.closeSearch();
      },
      fetchUsers () {
        this.$http.get(api+'api/v1/search/casino/'+this.search, {params: {q: this.search, raw: true, provider: this.provider, live: this.live} }).then(response => {
          // get body data
          var th = this;
          this.events = [];
          response.body.result.forEach(function(item) {
            th.events.push(item.game);
          });

          this.$emit('result', this.events);
          this.total  = response.body.result.length;
        }, response => {

        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.SearchIconEnd {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/casino/widget/gameSearch.vue